import { Injectable, Component, inject } from '@angular/core';
import { NgbModal } from '@otas/modal/modal';
import { AppConstants } from '../../../app.constants';
@Injectable()
export class AddOrUpdateAccHeadModalService {
    private modalService = inject(NgbModal);
    openModal(component: Component, componentInstance?) {
        const modalRef = this.modalService.open(component, AppConstants.largeModaloptions);
        modalRef.componentInstance.accountHeadToEdit = componentInstance.accountHeadToEdit;
        modalRef.componentInstance.accountHeadWithTitles = componentInstance.accountHeads;
        modalRef.componentInstance.accountParentHeadWithTitles = componentInstance.accountParentHeads;
        return modalRef;
    }
}

